import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'anf-core-react';

export default function ErrorDisplay({ apolloError }) {
  const errorText = useMemo(() => {
    if (!apolloError) return null;
    return <p>{apolloError.toString()}</p>;
  }, [apolloError]);

  return (
    <div data-testid="error-display">
      <ErrorMessage>
        An error has occurred.  Please reload the page and attempt your action again.

        {errorText}
      </ErrorMessage>
    </div>
  );
}

ErrorDisplay.propTypes = {
  apolloError: PropTypes.shape({
    toString: PropTypes.func,
  }),
};
